module.exports = __webpack_public_path__ + "media/images/checkout/garantia-30-dias-1668c76a6748fe3e915051152300e3df.png";